// Remembers the game you are currently playing, so other pages can offer a way back to it
// (and so the lobby does not let you start a second game at the same time).
import {useEffect, useState} from "react";

let activeGame = null;
const listeners = new Set();

export const setActiveGame = (state) => {
    activeGame = state;
    listeners.forEach((listener) => listener(state));
};

export const getActiveGame = () => activeGame;

export const useActiveGame = () => {
    const [value, setValue] = useState(activeGame);
    useEffect(() => {
        listeners.add(setValue);
        setValue(activeGame);
        return () => listeners.delete(setValue);
    }, []);
    return value;
};
